module.exports = __webpack_public_path__ + "static/media/COURT_ORDER.26f7c0de.pdf";